<template>
    <div>
        <h5 class="">Connect with us</h5>
        <div class="bodyCopy mv3">
            Email us at
            <a class="link white pointer">
                <span class="b"><MailTo address="inquiry@tooliaba.com" fontColor="white" subject="Inquiry"/></span>
            </a>
            with questions, comments, feedback or ideas. We would love to hear from you!
        </div>
        <div class="mv2 flex">
            <SocialMediaLink :image="require(`@/assets/img/social-media/icon_menu_facebook_darkgrey.svg`)"/>
            <SocialMediaLink :image="require(`@/assets/img/social-media/icon_menu_twitter_darkgrey.svg`)"/>
            <SocialMediaLink :image="require(`@/assets/img/social-media/icon_menu_instagram_darkgrey.svg`)"/>
            <SocialMediaLink :image="require(`@/assets/img/social-media/icon_menu_pinterest_darkgrey.svg`)"/>
        </div>
    </div>
</template>
<script>
import SocialMediaLink from '@/components/footer/connect/SocialMediaLink.vue';
import MailTo from '@/components/global/MailTo.vue';

export default {
    components: {
        MailTo,
        SocialMediaLink
    }
};
</script>
